var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconionicIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.602,
    height: 8.253,
    viewBox: "0 0 6.602 8.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-copy",
    "data-name": "Icon ionic-ios-copy",
    transform: "translate(-4.5 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61442",
    "data-name": "Path 61442",
    d: "M23.735,2.832h1.547a.1.1,0,0,0,.1-.1h0a.48.48,0,0,0-.172-.366l-1.326-1.1a.643.643,0,0,0-.354-.127h0a.127.127,0,0,0-.127.127V2.506A.329.329,0,0,0,23.735,2.832Z",
    transform: "translate(-14.284 -0.005)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61443",
    "data-name": "Path 61443",
    d: "M12.927,2.5V1.125H10.675a.552.552,0,0,0-.55.55V7.452a.552.552,0,0,0,.55.55H14.8a.552.552,0,0,0,.55-.55V3.274H13.7A.775.775,0,0,1,12.927,2.5Z",
    transform: "translate(-4.25 0)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61444",
    "data-name": "Path 61444",
    d: "M5.394,11.333V5.625H5.05a.552.552,0,0,0-.55.55v6.052a.552.552,0,0,0,.55.55h4.4a.552.552,0,0,0,.55-.55v-.344H5.944A.552.552,0,0,1,5.394,11.333Z",
    transform: "translate(0 -3.4)",
    fill: "#606060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIos);
export default __webpack_public_path__ + "static/media/Icon ionic-ios.cf4e0d98189dbac2703e8c492892243e.svg";
export { ForwardRef as ReactComponent };